import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { useState } from 'react';

import { AuthenticationModal } from '../../../../components/_molecules/AuthenticationModal/AuthenticationModal';
import DesignerSkeletonLoader from '../../../../components/_molecules/DesignerSkeletonLoader';
import { DesignerTopBarContainer } from '../../../../components/styled/CreatorTopBar';
import ActiveBackgroundProvider from '../../../../providers/ActiveBackgroundProvider';
import { detectAndBestEffortSetLanguage } from '../../../../utils/localisationUtils';

const FullPageCreatorLoader = () => {
  return (
    <>
      <DesignerTopBarContainer />
      <DesignerSkeletonLoader />
    </>
  );
};

const DesignerPage = dynamic(
  () => import('../../../../components/dynamicPages/DesignerPage'),
  { ssr: false, loading: () => <FullPageCreatorLoader /> },
);

const CreatorRootPage = () => {
  const router = useRouter();
  const session = useSession();
  const isAuthenticated = session.status === 'authenticated';

  // Get templateId from URL
  const templateId = router.query.templateId as string;

  const [showAuthModal, _] = useState(!isAuthenticated);

  const handleSignIn = () => {
    const currentPath = router.asPath;
    const signinUrl = `/signin?callback=${encodeURIComponent(currentPath)}`;
    router.push(signinUrl);
  };
  const handleSignUp = () => {
    const currentPath = router.asPath;
    const signupUrl = `/signup?callbackUrl=${encodeURIComponent(currentPath)}`;
    router.push(signupUrl);
  };
  return (
    <ActiveBackgroundProvider>
      {isAuthenticated ? (
        <DesignerPage />
      ) : session.status === 'loading' ? (
        <FullPageCreatorLoader />
      ) : (
        <>
          <FullPageCreatorLoader />
          <AuthenticationModal
            visible={showAuthModal}
            onSignIn={handleSignIn}
            onSignUp={handleSignUp}
            templateId={templateId}
          />
        </>
      )}
    </ActiveBackgroundProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  return {
    props: {
      ...(await detectAndBestEffortSetLanguage(context)),
    },
  };
};

export default CreatorRootPage;
